<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
<p class="normal-310-0-override4"><span class="no-style-override17"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="extended-quotes-311-0-override"><span class="no-style-override18"><br class="calibre1"/></span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override18"><br class="calibre1"/></span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override18">‘Those who look only to the past or present are certain to miss the future.’</span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override18">‘Forgive your enemies, but never forget their names.’</span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override19"><br class="calibre1"/></span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override19">– John Fitzgerald Kennedy</span></p>
<p class="extended-quotes-311-0-override"><span class="no-style-override19">35</span><span class="no-style-override20">th</span><span class="no-style-override19"> U.S. president</span></p>
<p class="normal-310-0-override5"><span class="no-style-override21"><br class="calibre1"/></span></p>
<p class="calibre3" id="calibre_pb_18"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Quote.vue?75593da9